@if (canOpenBreakdown()) {
<div
  class="progress-label-host"
  (mouseenter)="onBreakdownHostEnter()"
  (mouseleave)="onBreakdownHostLeave()"
  (click)="$event.stopPropagation()"
>
  <button
    type="button"
    class="progress-label-trigger"
    [class.progress-label-trigger--compact]="compact"
    [attr.aria-expanded]="breakdownOpen()"
    (click)="onBreakdownTriggerClick($event)"
  >
    <ng-container *ngTemplateOutlet="labelBody"></ng-container>
  </button>
</div>
} @else {
<span
  class="progress-label-trigger progress-label-trigger--static"
  [class.progress-label-trigger--compact]="compact"
  [matTooltip]="percentagesHelpTooltip()"
  matTooltipClass="duna-progress-label-help-tooltip"
>
  <ng-container *ngTemplateOutlet="labelBody"></ng-container>
</span>
}

<ng-template #breakdownPanel>
  <div
    class="progress-breakdown-popover"
    role="dialog"
    [attr.aria-label]="breakdownTitle()"
    (click)="$event.stopPropagation()"
  >
    <p class="progress-breakdown-title">{{ breakdownTitle() }}</p>
    <table class="progress-breakdown-table">
      <thead>
        <tr>
          <th>Veje</th>
          <th class="num">Deltaget</th>
          <th class="num">Tilmeldt</th>
          <th class="num">Krav</th>
        </tr>
      </thead>
      <tbody>
        @for (row of breakdownRows(); track row.pathId) {
        <tr class="path-row">
          <td>
            <div class="progress-breakdown-path-name" [title]="row.name">
              {{ row.name }}
            </div>
            <div class="progress-breakdown-path-pct">
              Deltaget {{ row.progressPercentage }}% · Tilmeldt
              {{ row.registeredPercentage }}%
            </div>
          </td>
          <td class="num">{{ formatMinutes(row.completed) }}</td>
          <td class="num">{{ formatMinutes(row.intended) }}</td>
          <td class="num">{{ formatMinutes(row.required) }}</td>
        </tr>
        }
        <tr class="total-row">
          <td>I alt</td>
          <td class="num">
            {{ formatMinutes(resolved().completed) }}
            ({{ resolved().progressPercentage }}%)
          </td>
          <td class="num">
            {{ formatMinutes(resolved().intended) }}
            ({{ resolved().registeredPercentage }}%)
          </td>
          <td class="num">{{ formatMinutes(resolved().required) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>

<ng-template #labelBody>
  <div class="progress-label-text">
    <span class="progress-label-primary">
      <span class="progress-label-kicker">Tilmeldt</span>
      <span class="progress-label-value">{{
        resolved().registeredPercentage
      }}%</span>
    </span>
    <span class="progress-label-secondary">
      <span class="progress-label-kicker">Deltaget</span>
      <span class="progress-label-value progress-label-value--muted">{{
        resolved().progressPercentage
      }}%</span>
    </span>
  </div>
  @if (showBar) {
  <div class="progress-label-bar" aria-hidden="true">
    <div
      class="bar-fill completed"
      [style.width.%]="completedBarWidth()"
    ></div>
    <div
      class="bar-fill intended"
      [style.width.%]="intendedBarWidth()"
    ></div>
  </div>
  }
</ng-template>
